module.exports = __webpack_public_path__ + "static/media/logo-horizontal-color.c6d5e147.png";